import { AssetField } from '@elementary/common-ui/services/gql/types';

export const COLUMN_TO_FIELD_MAP: Record<string, AssetField> = {
  name: 'NAME',
  assetType: 'DISPLAY_TYPE',
  owners: 'OWNER',
  tags: 'TAG',
  path: 'PATH',
  lastRunAt: 'LAST_EXECUTION_TIME',
  lastRunStatus: 'LAST_EXECUTION_STATUS',
  lastDataModificationTime: 'LAST_DATA_MODIFICATION_TIME',
  usage: 'TABLE_USAGE_PERCENTILE',
  materialization: 'BUILD_STRATEGY',
  isCritical: 'IS_CRITICAL',
  artifactType: 'ARTIFACT_TYPE',
  description: 'DESCRIPTION',
  dbName: 'DATABASE_NAME',
  schemaName: 'SCHEMA_NAME',
};

export const FIELD_TO_COLUMN_MAP: Partial<Record<AssetField, string>> =
  Object.fromEntries(
    Object.entries(COLUMN_TO_FIELD_MAP).map(([column, field]) => [
      field,
      column,
    ]),
  );
